import Dexie from 'dexie';

const db = new Dexie('KioskDB');

db.version(1).stores({
  // Key-value config store (device_token, device_info, admin_code, auto_sync, etc.)
  config: 'key',

  // Employee directory synced from server
  // Stores: id, displayName, firstName, lastName, kioskPin, department, role, avatarUrl, avatarBlob, lastUpdated
  employees: 'id, displayName, kioskPin, department',

  // All clock-in/out/break events (core offline data)
  // Stores: localId (auto), tempId, userId, action, timestamp, method, hasSelfie, breakTypeId,
  //         syncStatus (pending|synced|failed|conflict), syncedAt, serverCheckinId, createdAt
  clockEvents: '++localId, tempId, userId, action, timestamp, syncStatus, [userId+syncStatus]',

  // Selfie photo blobs keyed by event tempId (separate store for performance)
  // Stores: tempId, data (base64 string or Blob)
  selfies: 'tempId',

  // Company break type categories synced from server
  // Stores: id, companyId, name, isPaid, defaultDurationMinutes, sortOrder, isActive
  breakTypes: 'id, companyId',

  // History of sync operations for admin dashboard
  // Stores: id (auto), timestamp, status, eventsTotal, eventsSynced, eventsFailed, eventsConflict, durationMs
  syncLog: '++id, timestamp, status',
});

export default db;
